import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { href: "#gallery", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#reviews", label: "Reviews" },
  { href: "#quote", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[var(--rr-bg)]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 h-20 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex items-center group">
          <span className="font-display text-[15px] font-semibold tracking-tight text-white leading-tight">
            Rapid Response
            <span className="block text-[10px] font-medium tracking-[0.22em] text-[var(--rr-text-muted)] uppercase">
              Property Services
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-sm font-medium text-[var(--rr-text-muted)] hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="tel:+16109940500"
            data-testid="nav-call-btn"
            className="hidden md:inline-flex items-center gap-2 px-4 h-10 rounded-full border border-white/10 text-sm text-white hover:border-[var(--rr-accent)]/60 hover:text-[var(--rr-accent)] transition-colors"
          >
            <Phone className="h-3.5 w-3.5" />
            610.994.0500
          </a>
          <a
            href="#quote"
            data-testid="nav-quote-btn"
            className="hidden sm:inline-flex items-center px-5 h-10 rounded-full bg-[var(--rr-primary)] text-white text-sm font-semibold hover:bg-[var(--rr-primary-hover)] transition-colors shadow-[0_8px_24px_-12px_rgba(47,111,78,0.7)]"
          >
            Get Quote
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md border border-white/10 text-white"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-500 ${
          open ? "max-h-[420px]" : "max-h-0"
        } bg-[var(--rr-bg)]/95 backdrop-blur-xl border-b border-white/5`}
      >
        <nav className="px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
              className="text-base font-medium text-white py-2 border-b border-white/5"
            >
              {n.label}
            </a>
          ))}
          <a
            href="tel:+16109940500"
            data-testid="mobile-nav-call"
            className="mt-2 inline-flex items-center justify-center gap-2 h-11 rounded-full border border-white/10 text-white"
          >
            <Phone className="h-4 w-4" /> 610.994.0500
          </a>
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-quote"
            className="inline-flex items-center justify-center h-11 rounded-full bg-[var(--rr-primary)] text-white font-semibold"
          >
            Get Quote
          </a>
        </nav>
      </div>
    </header>
  );
}
